export default "__VITE_ASSET__84bad913__"